import { useEffect, useState } from 'react';
import PouzitiePredpis from '../model/PouzitiePredpis';
import { fetchPouzitiePredpisList } from '../client/pouzitiePredpisListClient';
import { useClient } from '../context/ClientStatusContext';
import { ClientStatus } from '../model/ClientStatus';

interface ReturnType {
  pouzitiePredpisList: PouzitiePredpis[];
  pouzitiePredpisListStatus: ClientStatus;
}

export default (
  searchText: string,
  limit: number,
): ReturnType => {
  const [, setAction] = useState(0);
  const { wrapClient, status, data } = useClient(fetchPouzitiePredpisList);

  useEffect(() => {
    setAction(prevState => {
      clearTimeout(prevState);
      return prevState;
    });

    const act = setTimeout(async () => {
      await wrapClient(searchText, [], limit);
    }, 300);

    // @ts-ignore
    setAction(act);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText, limit]);

  return {
    pouzitiePredpisList: data || [],
    pouzitiePredpisListStatus: status,
  };
};
